/**
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const Nat = require('../types/Nat')
const CElementBase = require('./CElementBase')
const NatObj = require('../types/NatObj')
module.exports = CElementGenerique

function CElementGenerique (impProto, estElementFinal) {
  // Le deuxième paramètre est null car un élémente générique n'a pas de liste propriétaire
  if (arguments.length === 0) CElementBase.call(this, null);
  else {
    CElementBase.call(this, null, impProto, estElementFinal);
  }
  this.nom = "";
  this.elementAssocie = null;
  this.natureGraphique = 0;
  this.natCal = 0;
}
CElementGenerique.prototype = new CElementBase();
CElementGenerique.prototype.constructor = CElementGenerique;
CElementGenerique.prototype.superClass = "CElementBase";
CElementGenerique.prototype.className = "CElementGenerique";

CElementGenerique.prototype.read = function(inps){
  this.nom = inps.readUTF();
  var ind = inps.readInt();
  this.natureGraphique = this.nature(ind);
  ind = inps.readInt();
  this.natCal = this.nature(ind);
};

CElementGenerique.prototype.write = function(oups, list){
  oups.writeUTF(this.nom);
  oups.writeInt(NatObj.indiceNatureGraphique(this.indiceDeNature(this.natureGraphique)));
  oups.writeInt(this.indiceDeNature(this.natCal));
};

CElementGenerique.prototype.getNature = function() {
  return this.natureGraphique;
};

CElementGenerique.prototype.getNatureCalcul = function() {
  return this.natCal;
};
// A revoir JavaScript
CElementGenerique.prototype.indiceDeNature = function(nature) {
  return NatObj.indiceDeNature(nature);
};

CElementGenerique.prototype.indiceNatureGraphique = function(indice) {
  if (indice < 30)  return indice;
  else return indice - 4;
};

CElementGenerique.prototype.nature = function(ind) {
  if (ind === -1) return new Nat(0, 0);
  else {
    var low = (ind < 31) ? (1 << ind) : 0;
    var high = (ind < 31) ? 0 : (1 << 32 - ind);
    return new Nat(low, high);
  }
}

